module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/map/marker-1-ad41686dc4adb1f96206c083dc27c419.svg";